import React, { useEffect, useState } from 'react'
import '../../css/growthWheel.scss'
import { useGetGrowthWheelByRoleIdQuery, useGetGrowthWheelWithEvaluationsByUserIdQuery } from '../../redux/growth-wheel.endpoints'
import { User } from '../../types/User'
import GrowthWheelDashboard from '../GrowthWheelDashboard/GrowthWheelDashboard'
import { CompetencyArea, CompetencyWithEvaluation } from '../../types/GrowthWheel'
import GrowthWheelCompetencyAreaView from '../GrowthWheelCompetencyAreaView/GrowthWheelCompetencyAreaView'
import GrowthWheelCompetencyAssessment from '../GrowthWheelCompetencyView/GrowthWheelCompetencyView'

const GrowthWheel = ({ user }: { user: User }) => {
  const roleId = user.guildId;
  const [currentCompetencyArea, setCurrentCompetencyArea] = useState<CompetencyArea | null>(null);
  const [currentCompetency, setCurrentCompetency] = useState<CompetencyWithEvaluation | null>(null);

  const { data: growthWheelData, isLoading } = useGetGrowthWheelByRoleIdQuery({ roleId: roleId })
  const { data: userCompetencyAreasData } = useGetGrowthWheelWithEvaluationsByUserIdQuery({ userId: user.id })

  useEffect(() => {
    if (!userCompetencyAreasData?.length) return
    if (currentCompetencyArea) {
      const freshArea = userCompetencyAreasData.find((a) => a.id === currentCompetencyArea.id)
      if (freshArea) {
        setCurrentCompetencyArea(freshArea)
        if (currentCompetency) {
          const freshCompetency = freshArea.competencies?.find((c) => c.id === currentCompetency.id)
          if (freshCompetency) setCurrentCompetency(freshCompetency)
        }
      }
    }
  }, [userCompetencyAreasData])

  const handleClickAreaChange = (competencyArea: CompetencyArea | null) => {
    setCurrentCompetencyArea(competencyArea)
  }

  const handleClickCompetencyChange = (competency: CompetencyWithEvaluation | null) => {
    setCurrentCompetency(competency)
  }

  const renderContentDeliveryView = () => {

    const displayAssessmentView = currentCompetency && currentCompetencyArea
    const displayAreaView = currentCompetencyArea && !currentCompetency
    const displayDashboardView = !currentCompetencyArea && growthWheelData

    if (displayAssessmentView) {
      return (<GrowthWheelCompetencyAssessment
        currentCompetency={currentCompetency}
        handleClickCompetencyChange={handleClickCompetencyChange}
        competencyList={currentCompetencyArea.competencies ?? []}
      />)
    }

    if (displayAreaView) {
      return (<GrowthWheelCompetencyAreaView
        userCompetencyAreasList={userCompetencyAreasData ?? []}
        currentCompetencyArea={currentCompetencyArea}
        handleClickAreaChange={handleClickAreaChange}
        handleClickCompetencyChange={handleClickCompetencyChange}
      />)
    }
    if (displayDashboardView) {
      return (<GrowthWheelDashboard
        userCompetencyAreasData={userCompetencyAreasData ?? []}
        handleClickCompetencyArea={handleClickAreaChange}
        growthWheelData={growthWheelData}
        isLoading={isLoading}
      />)
    }
    return null
  }

  return (
    <>
      {renderContentDeliveryView()}
    </>
  )
}

export default GrowthWheel